import { Component, HostListener, Input } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { MessageService } from "primeng/api";
import { AppComponent } from "src/app/app.component";
import { ScrBaseComponent } from "src/app/components/base.component";
import { ScrAuthenticationService, ScrServiceManager } from "src/app/services";


@Component({
  selector: 'app-id-token-dialog',
  templateUrl: './id-token-dialog.component.html'
})

export class IdTokenDialogComponent extends ScrBaseComponent {

  public idToken?: string;
  public refreshToken?: string;
  public parsedIdToken?: string;
  public idTokenExpiration: Date | null = null;
  public displayTokenDialog = false;

  @Input() public app!: AppComponent;

  constructor(private auth: ScrAuthenticationService, private messageService: MessageService, public sm: ScrServiceManager) {
    super();
  }

  @HostListener('document:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.defaultPrevented) {
      return;
    }
    if ((event.code === 'KeyJ') && (event.altKey)) {
      this.getMyToken();
      event.preventDefault();
    }

  }

  getMyToken(): void {
    this.auth.userIsSignedIn().then(b => {
      if (!b) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'You must be signed in to get your Cognito token.'
        });
        return;
      }

      this.refreshToken = this.auth.getRefreshToken();

      this.auth.getIdToken().then(t => {
        this.idToken = t;
        if (t) {
          const s = new JwtHelperService();
          const decoded = s.decodeToken(t);
          this.idTokenExpiration = s.getTokenExpirationDate(t);
          this.parsedIdToken = JSON.stringify(decoded, undefined, 2);
          this.displayTokenDialog = true;
        }
      });
    });
  }

  refreshSession(): void {
    const astate = this.auth.getAuthState();
    if (astate?.username && astate?.refreshToken) {
      this.auth.exchangeRefreshToken(astate?.username).subscribe({
        next: (updated) => {
          this.log.trace('updated ' + updated);
          const astate = this.auth.getAuthState();
          this.log.trace('updated tokens ' + astate?.idToken + ' ' + astate?.refreshToken);
          this.idToken = astate?.idToken;
          if (astate?.idToken) {
            const s = new JwtHelperService();
            const decoded = s.decodeToken(astate.idToken);
            this.parsedIdToken = JSON.stringify(decoded, undefined, 2);
            this.displayTokenDialog = true;

            this.refreshToken = astate?.refreshToken;
          }
        },
        error: (err) => {
          this.log.warn('error refreshing session ' + err);
          this.displayTokenDialog = false;
        }
      });
    }
    this.sm.outstandingRequestCount.subscribe((count: number) => {
      this.app.setOutstanding(count);
    });
  }
}